// store/modules/register.js
export default {
    namespaced: true,
    state: () => ({
        newUser: null
    }),
    mutations: {
        setNewUser(state, payload) {
            state.newUser = payload
        }
    }
}
